import { FormProvider } from "react-hook-form";
import { type FC, type PropsWithChildren } from "react";
import classNames from "classnames";
import type { SubmitHandler, UseFormReturn } from "react-hook-form";
import styles from "./styles.module.scss";

type Props = {
  formApi: UseFormReturn<any>;
  onSubmit?: SubmitHandler<any>;
  className?: string;
};

export const AppForm: FC<PropsWithChildren<Props>> = ({
  onSubmit = () => {},
  formApi,
  children,
  className,
}) => {
  return (
    <FormProvider {...formApi}>
      <form
        className={classNames(styles.form, className)}
        onSubmit={formApi.handleSubmit(onSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  );
};
